// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Axios from 'axios'
import VueTheMask from 'vue-the-mask'

Vue.config.productionTip = false
Vue.prototype.$http = Axios

Vue.use(VueTheMask)

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

Vue.directive('short-description', {
    inserted: function(el, binding) {
        let s = binding.value.htmlText
        let temp = document.createElement('div')
        temp.innerHTML = s
        let htmlObject = temp.firstChild
        el.textContent = htmlObject.innerHTML.substr(0, binding.value.count) + '...'
    }
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js